import { useEffect } from "react";
import { createVitals } from "../services/v5Api";

const useVitalsListener = (seniorId, onSuccess, onError) => {
  useEffect(() => {
    // Define the handler function
    const handleMessage = (event) => {
      // Parse the event data if it's a string (PostMessage often sends strings)
      let data = event.data;
      if (typeof data === "string") {
        try {
          data = JSON.parse(data);
        } catch (e) {
          // Ignore if not JSON
        }
      }

      // Check if the message is relevant
      if (data && data.type === "VITALS_RESULT") {
        console.log("VITALS_RESULT received:", data);

        if (!seniorId) {
          console.warn("Vitals received but no seniorId provided.");
          return;
        }

        const payload = {
          timestamp: new Date().toISOString(),
          vitals: data.payload,
        };

        createVitals(payload, seniorId)
          .then((response) => {
            console.log("Vitals created successfully:", response);
            if (onSuccess) onSuccess();
          })
          .catch((error) => {
            console.error("Error creating vitals:", error);
            if (onError) onError(error);
          });
      }
    };

    // Add event listener
    // React Native WebView postMessage comes via 'message' event on window/document depending on implementation
    // Standard web is window.addEventListener("message", ...)
    window.addEventListener("message", handleMessage);
    document.addEventListener("message", handleMessage); // Sometimes needed for Android/iOS WebViews

    // Cleanup
    return () => {
      window.removeEventListener("message", handleMessage);
      document.removeEventListener("message", handleMessage);
    };
  }, [seniorId, onSuccess, onError]);
};

export default useVitalsListener;
